import { browser } from '$app/env';
import { onDestroy, onMount } from 'svelte';

const ACTIVITY_EVENTS = ['pointermove', 'keydown', 'touchstart'] as const;

/**
 * Calls `onIdle` once when the user has been inactive for `timeoutMs` milliseconds,
 * and `onActive` once when they return. Fires once per idle/active cycle.
 * Automatically registers/cleans up event listeners and the interval.
 */
export function useIdleCallback(onIdle: () => void, timeoutMs = 60_000, onActive?: () => void) {
  let lastActivity = Date.now();
  let isIdle = false;
  let timer: ReturnType<typeof setInterval>;

  const resetTimer = () => {
    if (isIdle) {
      isIdle = false;
      onActive?.();
    }
    lastActivity = Date.now();
  };

  onMount(() => {
    for (const event of ACTIVITY_EVENTS) {
      window.addEventListener(event, resetTimer);
    }

    timer = setInterval(() => {
      if (!isIdle && Date.now() - lastActivity >= timeoutMs) {
        isIdle = true;
        lastActivity = Date.now();
        onIdle();
      }
    }, 60_000);
  });

  onDestroy(() => {
    if (!browser) return;
    for (const event of ACTIVITY_EVENTS) {
      window.removeEventListener(event, resetTimer);
    }
    clearInterval(timer);
  });
}
